/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {useIntl} from 'react-intl'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import Link from '../../../components/link'
import LinksList from '../../../components/links-list'
import {StokkeWordBrandLogo} from '../../../components/icons'
import PaymentIcons from '../../../components/footer/payment-icons'
import ShippingIcons from '../../../components/footer/shipping-icons'
import {useOcapiContent} from '../../../hooks/useOcapi'
import {HOME_HREF} from '../../../constants'

const CheckoutFooter = () => {
    const styles = useMultiStyleConfig('FooterContent')
    const intl = useIntl()
    const {data: footerContent} = useOcapiContent({parameters: {cid: 'pwa_footer_checkout'}})
    if (!footerContent) {
        return null
    }
    const brandText = intl.formatMessage({defaultMessage: 'STOKKE Logo', id: 'global.brand_logo'})
    const backToHomePage = intl.formatMessage({
        defaultMessage: 'Back to homepage',
        id: 'global.back_to_home'
    })
    const links = footerContent?.c_body?.innerJSON?.links || {items: []}

    return (
        <Box as="footer" {...styles.container}>
            <Box {...styles.content.boxing}>
                <Flex {...styles.content}>
                    <Box {...styles.StokkeWordBrandLogo.link}>
                        <Link href={HOME_HREF} title={backToHomePage} variant="image">
                            <StokkeWordBrandLogo
                                {...styles.StokkeWordBrandLogo.logo}
                                role="img"
                                aria-label={brandText}
                            />
                        </Link>
                    </Box>
                    {links?.items?.length && (
                        <Box {...styles.footerLinkContainer}>
                            <LinksList variant="checkoutFooter" links={links.items} />
                        </Box>
                    )}
                    <Box {...styles.footerIconContainer}>
                        <PaymentIcons />
                        <ShippingIcons />
                    </Box>
                </Flex>
            </Box>
        </Box>
    )
}

export default CheckoutFooter
